// frontend/src/features/user/services/usersAPI.ts
import api from '../../../services/apiConfig';

export interface User {
  ID_USUARIO: number;
  ID_VENDEDOR: string;
  BASE: number;
  ID_PARCERIA: string;
  USUARIO: string;
  NOME: string;
  SENHA: string;
  EMAIL: string;
  UsuarioAdm: number;
  UsuarioVendas: number;
  Usuario_carteira: number;
  UsuarioDeshboard: number;
  UsuarioSupervisor: number;
  UsuarioDiretoria: number;
  usuarioAmostras: number;
  usuarioCabedal: number;
  usuarioCorte: number;
  usuarioPlanos: number;
  UsuarioStrobel: number;
  UsuarioIlhos: number;
  UsuarioExpedicao: number;
  UsuarioMapas: number;
  UsuarioInjetora: number;
  UsuarioPcp: number;
  UsuarioGerentePcp: number;
  UsuarioEsteira: number;
  UsuarioFechamento: number;
  UsuarioEstoque: number;
  UsuarioPcpFaturamento: number;
  UsuarioContabiliza: number;
  UsuarioSetor: number;
  UsuarioControladoria: number;
  SupervisorRegional: number;
  UsuarioGerente: number;
  UsuarioJJSolucoes: number;
  UsuarioConferencia: number;
  UsuarioCurtume: number;
  UsuarioQualidade: number;
  UsuarioSac: number;
  UsuarioProgPedidos: number;
  UsuarioCarregamento: number;
  UsuarioContagemCabedal: number;
  UsuarioArquivos: number;
  UsuarioLogistica: number;
  portaria: number;
  UsuarioEnderecos: number;
  UsuarioSegTrab: number;
  UsuarioControleLogistica: number;
  AcessoAnalytics: number;
  AcessoEntregas: number;
  AcessoVeiculos: number;
  AcessoFrota: number;
  AcessoVolumetria: number;
  usuarioCRM: string;
  ultimo_acesso: string;
}

export interface Base {
  ID: number;
  COD: number;
  BASE: string;
  REGIONAL: string;
  SUPERVISOR: string;
  REGIONAL_NOME: string;
}

export interface Cliente {
  ID: number;
  NOME: string;
  FANTASIA: string;
  BASE: number;
  VENDEDOR: number;
}

export interface CreateUserData {
  ID_VENDEDOR?: string;
  BASE?: number; // [AJUSTE - TAREFA A4] Base não é obrigatória
  USUARIO: string;
  NOME: string;
  SENHA: string;
  EMAIL?: string; // [AJUSTE - TAREFA A4] Email não é obrigatório
  UsuarioAdm?: number;
  UsuarioVendas?: number;
  Usuario_carteira?: number;
  UsuarioDeshboard?: number;
  UsuarioSupervisor?: number;
  UsuarioDiretoria?: number;
  usuarioAmostras?: number;
  usuarioCabedal?: number;
  usuarioCorte?: number;
  usuarioPlanos?: number;
  UsuarioStrobel?: number;
  UsuarioIlhos?: number;
  UsuarioExpedicao?: number;
  UsuarioMapas?: number;
  UsuarioInjetora?: number;
  UsuarioPcp?: number;
  UsuarioGerentePcp?: number;
  UsuarioEsteira?: number;
  UsuarioFechamento?: number;
  UsuarioEstoque?: number;
  UsuarioPcpFaturamento?: number;
  UsuarioContabiliza?: number;
  UsuarioSetor?: number;
  UsuarioControladoria?: number;
  SupervisorRegional?: number;
  UsuarioGerente?: number;
  UsuarioJJSolucoes?: number;
  UsuarioConferencia?: number;
  UsuarioCurtume?: number;
  UsuarioQualidade?: number;
  UsuarioSac?: number;
  UsuarioProgPedidos?: number;
  UsuarioCarregamento?: number;
  UsuarioContagemCabedal?: number;
  UsuarioArquivos?: number;
  UsuarioLogistica?: number;
  portaria?: number;
  UsuarioEnderecos?: number;
  UsuarioSegTrab?: number;
  UsuarioControleLogistica?: number;
  AcessoAnalytics?: number;
  AcessoEntregas?: number;
  AcessoVeiculos?: number;
  AcessoFrota?: number;
  AcessoVolumetria?: number;
}

export interface UpdateUserData extends CreateUserData {
  ID_USUARIO: number;
}

// ==================== PERMISSÕES ====================

/** Colunas binárias (0/1) da tabela usuariosproducao — usadas para gerar checkboxes */
export const PERMISSION_FIELDS: { key: string; label: string }[] = [
  { key: 'UsuarioAdm', label: 'Administrador' },
  { key: 'UsuarioDiretoria', label: 'Diretoria' },
  { key: 'UsuarioSupervisor', label: 'Supervisor' },
  { key: 'SupervisorRegional', label: 'Supervisor Regional' },
  { key: 'UsuarioGerente', label: 'Gerente' },
  { key: 'UsuarioControladoria', label: 'Controladoria' },
  { key: 'UsuarioSetor', label: 'Setor' },
  { key: 'UsuarioVendas', label: 'Vendas' },
  { key: 'Usuario_carteira', label: 'Carteira de Clientes' },
  { key: 'UsuarioDeshboard', label: 'Dashboard' },
  { key: 'usuarioAmostras', label: 'Amostras' },
  { key: 'usuarioCabedal', label: 'Cabedal' },
  { key: 'usuarioCorte', label: 'Corte' },
  { key: 'usuarioPlanos', label: 'Planos' },
  { key: 'UsuarioStrobel', label: 'Strobel' },
  { key: 'UsuarioIlhos', label: 'Ilhós' },
  { key: 'UsuarioExpedicao', label: 'Expedição' },
  { key: 'UsuarioMapas', label: 'Mapas' },
  { key: 'UsuarioInjetora', label: 'Injetora' },
  { key: 'UsuarioPcp', label: 'PCP' },
  { key: 'UsuarioGerentePcp', label: 'Gerente PCP' },
  { key: 'UsuarioEsteira', label: 'Esteira' },
  { key: 'UsuarioFechamento', label: 'Fechamento' },
  { key: 'UsuarioEstoque', label: 'Estoque' },
  { key: 'UsuarioPcpFaturamento', label: 'PCP Faturamento' },
  { key: 'UsuarioContabiliza', label: 'Contabiliza' },
  { key: 'UsuarioJJSolucoes', label: 'JJ Soluções' },
  { key: 'UsuarioConferencia', label: 'Conferência' },
  { key: 'UsuarioCurtume', label: 'Curtume' },
  { key: 'UsuarioQualidade', label: 'Qualidade' },
  { key: 'UsuarioSac', label: 'SAC' },
  { key: 'UsuarioProgPedidos', label: 'Prog. Pedidos' },
  { key: 'UsuarioCarregamento', label: 'Carregamento' },
  { key: 'UsuarioContagemCabedal', label: 'Contagem Cabedal' },
  { key: 'UsuarioArquivos', label: 'Arquivos' },
  { key: 'UsuarioLogistica', label: 'Logística' },
  { key: 'portaria', label: 'Portaria' },
  { key: 'UsuarioEnderecos', label: 'Endereços' },
  { key: 'UsuarioSegTrab', label: 'Seg. Trabalho' },
  { key: 'UsuarioControleLogistica', label: 'Controle Logística' },
  { key: 'AcessoAnalytics', label: 'Analytics' },
  { key: 'AcessoEntregas', label: 'Entregas' },
  { key: 'AcessoVeiculos', label: 'Veículos' },
  { key: 'AcessoFrota', label: 'Frota' },
  { key: 'AcessoVolumetria', label: 'Volumetria' },
];

// ==================== CONSULTAS ====================

// Obter perfil do usuário logado
export const getUserProfile = async (): Promise<User> => {
  const response = await api.get('/users/me');
  return response.data;
};

// Obter todos os usuários (apenas admin)
export const getAllUsers = async (): Promise<User[]> => {
  const response = await api.get('/users');
  return response.data;
};

// Obter usuário por ID (apenas admin)
export const getUserById = async (id: number): Promise<User> => {
  const response = await api.get(`/users/${id}`);
  return response.data;
};

// Obter todas as bases
export const getAllBases = async (): Promise<Base[]> => {
  const response = await api.get('/users/bases');
  return response.data;
};

// Obter clientes de uma base
export const getClientesByBase = async (baseId: number): Promise<Cliente[]> => {
  const response = await api.get(`/users/bases/${baseId}/clientes`);
  return response.data;
};

// [NOVO MÉTODO - TAREFA I2] Obter clientes por ID Vendedor
export const getClientsByVendor = async (vendorId: string): Promise<Cliente[]> => {
  const response = await api.get(`/users/vendedor/${vendorId}/clientes`);
  return response.data;
};

export const getAllClientes = async (): Promise<Cliente[]> => {
  const response = await api.get('/users/clientes/all');
  return response.data;
};


// ==================== CRUD ====================

// Criar usuário
export const createUser = async (userData: CreateUserData): Promise<{ message: string; userId: number }> => {
  const response = await api.post('/users', userData);
  return response.data;
};

// Atualizar usuário
export const updateUser = async (id: number, userData: Partial<CreateUserData>): Promise<{ message: string }> => {
  const response = await api.put(`/users/${id}`, userData);
  return response.data;
};

// Excluir usuário
export const deleteUser = async (id: number): Promise<{ message: string }> => {
  const response = await api.delete(`/users/${id}`);
  return response.data;
};

// Editar vendedor (campos básicos)
export const editVendedor = async (id: number, data: { NOME?: string; SENHA?: string; LIVRE?: string }): Promise<{ success: boolean; message: string }> => {
  const response = await api.put(`/users/edit-vendedor/${id}`, data);
  return response.data;
};

// [TAREFA I1] Atribuir clientes a um usuário
export const assignClientes = async (userId: number, clienteIds: number[]): Promise<{ message: string }> => {
  const response = await api.post(`/users/${userId}/assign-clientes`, { clienteIds });
  return response.data;
};

// Transferir clientes de um vendedor para outro
export const transferClientes = async (
  vendedorOrigem: number | string,
  vendedorDestino: number | string,
  clienteIds: number[]
): Promise<{ success: boolean; message: string }> => {
  const response = await api.post('/users/transfer-clientes', {
    vendedorOrigem,
    vendedorDestino,
    clienteIds
  });
  return response.data;
};


// ==================== CREATE VENDEDOR (NOVO FLUXO COMPLETO) ====================

export interface CreateVendedorData {
  nome: string;
  usuario: string;
  senha: string;
  tipo: 'vendedor' | 'representante';
  livre?: string;
  grupo?: string;
  empresa?: string;
  regional?: string;
  supervisor?: string;
  tipoPessoa?: string;
}

export interface CreateVendedorResponse {
  success: boolean;
  message: string;
  ids: {
    usuarioId: number;
    suporteVendedorId: number;
    televendasVendedorId: number;
    baseId: number;
    usuariosproducaoId: number;
  };
}

// Criar vendedor completo (4 tabelas em transação)
export const createVendedor = async (data: CreateVendedorData): Promise<CreateVendedorResponse> => {
  const response = await api.post('/users/create-vendedor', data);
  return response.data;
};

// Verificar se usuário já existe
export const checkUsuarioExists = async (usuario: string): Promise<{ exists: boolean }> => {
  const response = await api.get(`/users/check-usuario/${encodeURIComponent(usuario)}`);
  return response.data;
};

// Selects para formulários
export const getSelectEmpresas = async (): Promise<string[]> => {
  const response = await api.get('/users/select/empresas');
  return response.data.map((r: any) => r.EMPRESA);
};

export const getSelectRegionais = async (): Promise<string[]> => {
  const response = await api.get('/users/select/regionais');
  return response.data.map((r: any) => r.REGIONAL);
};

export const getSelectSupervisores = async (): Promise<string[]> => {
  const response = await api.get('/users/select/supervisores');
  return response.data.map((r: any) => r.SUPERVISOR);
};

export const getSelectGrupos = async (): Promise<string[]> => {
  const response = await api.get('/users/select/grupos');
  return response.data.map((r: any) => r.GRUPO);
};

export const getSelectLivre = async (): Promise<string[]> => {
  const response = await api.get('/users/select/livre');
  return response.data.map((r: any) => r.LIVRE);
};